'use client'

import type { Dispatch, MutableRefObject, SetStateAction } from 'react'
import { useToast } from '@/app/context/toast-provider'
import { updatePanelistFeedbackRequest } from '@/app/utils/handlers/client/interview'
import { requestHandler } from '@/app/utils/requestHandler'

export type PanelistFeedbackUpdate = {
    email: string
    interviewRoundId: number
    recommendation?: string
    comment?: string
    finalFeedback?: string
}

export type UseUpdatePanelistFeedbackOptions = {
    interview: any
    setInterview: Dispatch<SetStateAction<any>>
    emailRef?: MutableRefObject<string | null>
    setRequestLoading?: (loading: boolean) => void
}

/** Sets a panelist's recommendation (and comments) on a round, then takes the interview from the response. */
export function useUpdatePanelistFeedback({ interview, setInterview, emailRef, setRequestLoading }: UseUpdatePanelistFeedbackOptions) {
    const { showErrorToast, showSuccessToast } = useToast()

    return (updatedValues: PanelistFeedbackUpdate) =>
        requestHandler(
            async () =>
                updatePanelistFeedbackRequest(interview?.id, {
                    email: updatedValues.email,
                    interviewRoundId: updatedValues.interviewRoundId,
                    recommendation: updatedValues.recommendation,
                    comments: updatedValues.comment,
                    finalFeedback: updatedValues.finalFeedback,
                }),
            (res) => {
                const { data, message } = res
                setInterview({ ...data, email: interview?.email || emailRef?.current })
                showSuccessToast(message)
            },
            (errMessage) => showErrorToast(errMessage),
            setRequestLoading ?? null
        )
}
